import { render, staticRenderFns } from "./MatchedList.vue?vue&type=template&id=38a1c248&"
import script from "./MatchedList.vue?vue&type=script&lang=js&"
export * from "./MatchedList.vue?vue&type=script&lang=js&"
import style0 from "./MatchedList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports